/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGroup
 */
export interface UpdateGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroup
     */
    groupName: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UpdateGroup
     */
    fields: Set<string>;
}

/**
 * Check if a given object implements the UpdateGroup interface.
 */
export function instanceOfUpdateGroup(value: object): value is UpdateGroup {
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function UpdateGroupFromJSON(json: any): UpdateGroup {
    return UpdateGroupFromJSONTyped(json, false);
}

export function UpdateGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'groupName': json['groupName'],
        'fields': new Set(json['fields']),
    };
}

export function UpdateGroupToJSON(json: any): UpdateGroup {
    return UpdateGroupToJSONTyped(json, false);
}

export function UpdateGroupToJSONTyped(value?: UpdateGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupName': value['groupName'],
        'fields': Array.from(value['fields'] as Set<any>),
    };
}

